import type { LinkMouseEvent } from "./types";

import { useSegmentAnalytics } from "./useSegmentAnalytics";

type RebateCardEvent = {
  rebateTaNumber: string;
  rebateTaBalance: string;
  rebateTaCurrency: string;
};

export const useEarningsPageAnalytics = () => {
  const { trackLinkClickEvent } = useSegmentAnalytics();

  const trackRebateCardTransferEvent = (
    event: LinkMouseEvent,
    { rebateTaNumber, rebateTaBalance, rebateTaCurrency }: RebateCardEvent,
  ) =>
    trackLinkClickEvent({
      event,
      label: "Transfer",
      location: "Earnings page",
      extraProperties: {
        rebate_ta_number: rebateTaNumber,
        rebate_ta_balance: rebateTaBalance,
        rebate_ta_currency: rebateTaCurrency,
      },
    });

  const trackRebateCardWithdrawEvent = (
    event: LinkMouseEvent,
    { rebateTaNumber, rebateTaBalance, rebateTaCurrency }: RebateCardEvent,
  ) =>
    trackLinkClickEvent({
      event,
      label: "Withdraw",
      location: "Earnings page",
      extraProperties: {
        rebate_ta_number: rebateTaNumber,
        rebate_ta_balance: rebateTaBalance,
        rebate_ta_currency: rebateTaCurrency,
      },
    });

  const trackRebateCardSettingsEvent = (
    event: LinkMouseEvent,
    { rebateTaNumber }: Pick<RebateCardEvent, "rebateTaNumber">,
  ) =>
    trackLinkClickEvent({
      event,
      label: "Settings cog",
      location: "Earnings page",
      extraProperties: {
        rebate_ta_number: rebateTaNumber,
      },
    });

  return {
    trackRebateCardTransferEvent,
    trackRebateCardWithdrawEvent,
    trackRebateCardSettingsEvent,
  };
};
